


import React, { PureComponent } from 'react';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer, PieChart, Pie, Cell } from 'recharts';

const data = [
  { name: 'MON', savings: 4000, investment: 2400, 'Asset financing': 3000, amt: 2400 },
  { name: 'TUE', savings: 3000, investment: 1398, 'Asset financing': 3070, amt: 2210 },
  { name: 'WED', savings: 2000, investment: 9800, 'Asset financing': 4600, amt: 2290 },
  { name: 'THUR', savings: 2780, investment: 3908, 'Asset financing': 3780, amt: 2000 },
  { name: 'FRI', savings: 1890, investment: 4800, 'Asset financing': 7900, amt: 2181 },
  { name: 'SAT', savings: 2390, investment: 3800, 'Asset financing': 3400, amt: 2500 },
  { name: 'SUN', savings: 3490, investment: 4300, 'Asset financing': 1500, amt: 2100 },
];

const pieData = [
  { name: 'Savings', value: data.reduce((sum, entry) => sum + entry.savings, 0) },
  { name: 'Investment', value: data.reduce((sum, entry) => sum + entry.investment, 0) },
  { name: 'Asset financing', value: data.reduce((sum, entry) => sum + entry['Asset financing'], 0) },
];

const COLORS = ['#F79009', '#17B26A', '#8046F2'];

export default class Chart extends PureComponent {
  state = {
    opacity: {
      balance: 1,
      payout: 1,
    },
  };

  handleMouseEnter = (o) => {
    const { dataKey } = o;
    const { opacity } = this.state;
    this.setState({
      opacity: { ...opacity, [dataKey]: 0.5 },
    });
  };

  handleMouseLeave = (o) => {
    const { dataKey } = o;
    const { opacity } = this.state;
    this.setState({
      opacity: { ...opacity, [dataKey]: 1 },
    });
  };

  render() {
    const { opacity } = this.state;

    return (
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        
        <div className="rounded-lg border border-gray-200 p-3">
          <div className="flex my-6 justify-between flex-wrap gap-3">
            <p className="text-[16px] font-[400]">Inflow & Outflow of cash</p>
            <div className="flex gap-4 text-sm">
              <p className="border-b-2 border-primary-color cursor-pointer">Daily</p>
              <p className="cursor-pointer">Weekly</p>
              <p className="cursor-pointer">Monthly</p>
              <p className="cursor-pointer">Yearly</p>
            </div>
          </div>

          <div className="ml-2 flex gap-4 flex-wrap">
            <div className="flex items-center gap-2">
              <span className="p-2 rounded-full bg-primary-color"></span>
              <p className="text-[14px] font-semibold text-gray-500">Amount invested: NGN 5,000,000</p>
            </div>
            <div className="flex items-center gap-2">
              <span className="p-2 rounded-full bg-[#F7941D]"></span>
              <p className="text-[14px] font-semibold text-gray-500">Payout: NGN 5,000,000</p>
            </div>
          </div>

          <ResponsiveContainer width="100%" height={300}>
            <LineChart
              data={data}
              margin={{ top: 5, right: 30, left: 20, bottom: 5 }}
            >
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis dataKey="name" stroke="#666" tick={{ fontSize: 12, fill: '#666' }} />
              <YAxis stroke="#666" tick={{ fontSize: 12, fill: '#666' }} />
              <Tooltip />
              <Legend onMouseEnter={this.handleMouseEnter} onMouseLeave={this.handleMouseLeave} />
              <Line type="monotone" dataKey="investment" strokeOpacity={opacity.pv} stroke="#F7941D" activeDot={{ r: 8 }} />
              <Line type="monotone" dataKey="savings" strokeOpacity={opacity.uv} stroke="#00BC67" />
              <Line type="monotone" dataKey="Asset financing" strokeOpacity={opacity.uv} stroke="#8046F2" />
            </LineChart>
          </ResponsiveContainer>
        </div>

        <div className="rounded-lg border border-gray-200 p-3">
          <h1 className="mb-4">Portfolio</h1>

          <div className="flex items-center justify-center">
            <ResponsiveContainer width="100%" height={300}>
              <PieChart>
                <Pie
                  data={pieData} 
                  cx="50%"
                  cy="50%"
                  innerRadius={60}
                  outerRadius={120}
                  fill="#8884d8"
                  paddingAngle={-1}
                  dataKey="value"
                  labelLine={false} 
                  // label={({ name, percent }) => `${name} (${(percent * 100).toFixed(0)}%)`} // Optional: Adds percentage labels
                >
                  {pieData.map((entry, index) => (
                    <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
                  ))}
                </Pie>
                <Tooltip /> 
              </PieChart>
            </ResponsiveContainer>
          </div>

          <div className="flex justify-center gap-5 mt-2 text-sm">
            <p className="text-orange-400">Investments</p>
            <p className="text-green-500">Savings</p>
            <p className="text-primary-color">Asset financing</p>
          </div>
        </div>

      </div>
    );
  }
}